import React from 'react'
import './Toggle.css'

const Toggle = ({ 
  checked = false, 
  onChange, 
  disabled = false, 
  id = '',
  className = '',
  ...props 
}) => {
  const classes = [
    'toggle',
    checked && 'toggle-checked',
    disabled && 'toggle-disabled',
    className
  ].filter(Boolean).join(' ')

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.checked)
    }
  }

  return (
    <label className="toggle-wrapper">
      <input
        type="checkbox"
        id={id}
        className="toggle-input"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        {...props}
      />
      <div className={classes}>
        <div className="toggle-slider"></div>
      </div>
    </label>
  )
}

export default Toggle
